export default __webpack_public_path__ + "static/media/ecell.085b339a.png";